






























































/* ----------------------------------------
    Imports
---------------------------------------- */

import { Component, Watch, Vue } from 'vue-property-decorator';
import { debounce } from 'lodash';
import { OrganisationService } from '@store/service/OrganisationService';
import StoreDispatcher from '@service/StoreDispatcher';
import { StepMixin, PopupMixin } from '@mixin';
import TextHighlight from 'vue-text-highlight';

/* ----------------------------------------
    Component
---------------------------------------- */

@Component({
    data() {
        return {
            next: {
                disabled: true,
            },
            autosave: false,
            search: {
                query: '',
                count: null,
                results: null,
                resultQuery: null,
                fetching: 0,
            },
            selected: null,
        };
    },

    components: {
        TextHighlight,
    },

    mixins: [
        StepMixin,
        PopupMixin,
    ],

    created() {
        this.organisationService = new OrganisationService(this.$store);
    },

    computed: {
        cResults() {
            return (this.search.results) ? this.search.results.slice(0, 15) : null;
        },
    },

    methods: {

        getSearchResults: debounce(function(query) {
            if (!query) {
                this.search.count = null;
                this.search.results = null;
                this.search.resultQuery = null;
                return;
            }

            this.search.fetching++;

            this.organisationService.getSearchResults(query)
                .then(response => {
                    this.search.count = response.count;
                    this.search.results = response.data;
                    this.search.resultQuery = response.query;
                    this.search.fetching--;
                });
        }, 1000),

        highlightQuery(text) {
            return `<strong>${ text }</strong>`;
        },

        submit() {
            return;
        },

        selectOrg(organisatie) {
            this.selected = organisatie;
            this.next.disabled = false;
        },

        deselectOrg() {
            this.selected = null;
            this.next.disabled = true;
        },

        async onNext() {
            const data = {
                organisation_id: this.selected.id
            };
            
            return StoreDispatcher.createProject(data).then(response => {
                if (response instanceof Error) {
                    this.errorData = this.getErrorMessage(response);
                    return false;
                }

                const project = response;
                
                // Fetch list again
                return StoreDispatcher.fetchOrganisationList().then(() => {
                    return `/apply/${ project.id }/applicant/kvk`;
                });
            });
        }
    }
})

/* ----------------------------------------
    Export
---------------------------------------- */

export default class VindOrganisatie extends Vue {
    @Watch('search.query')
    onQueryChange(query) {
        this.getSearchResults(query);
    }
}

